/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { FlexMiddleStyled } from '../../Block/Flexbox';

export const ChartErrorContainerStyled = styled(FlexMiddleStyled)`
    position: relative;
    flex-direction: column;
    width: 600px;
    height: 388px;
    margin: 0 auto;
    background: ${colors.chartErrorColorSquare};
`;

export const ChartSubTextStyled = styled.div`
    width: 300px;
    text-align: center;
    color: ${colors.textColorOpacity};
`;

export const ChartErrorTextStyled = styled.div`
    color: ${colors.textColorOpacity};
`;

export const ChartEmptyTextStyled = styled.div`
    margin-bottom: 8px;
    ${fonts.textMainBold};
`;
